import React from "react";

const Header = () => {
  return (
    <head>
      <meta charset="UTF-8" />
      <title>Rainference.com</title>
    </head>
  );
};

export default Header;


